<app-breadcrumbs></app-breadcrumbs>
<button
  class="back-button"
  *ngIf="auth.userMustCompleteProfile"
  (click)="auth.logout()"
>
  Back
</button>
<section class="form-wrapper">
  <div class="form-with-cover" *ngIf="detailsControl">
    <div class="form-container">
      <div class="form-title-container">
        <h1>
          My Insurance
          <span *ngIf="auth.currentUser?.coverCount"
            >(<span class="cover-count">{{ auth.currentUser?.coverCount }}</span
            >)</span
          >
        </h1>
        <p *ngIf="!auth.userMustCompleteProfile">
          <ng-container
            *ngIf="auth.userMustCompleteProfile; else standardMessage"
          >
            {{
              pageData.my_insurance_intro_migrated ||
                'Please update your details below so we know which Univeristy and Accommodation you have.'
            }}
          </ng-container>
          <ng-template #standardMessage>
            {{
              pageData.my_insurance_intro ||
                'If your university or where are you staying information has changed, please update your details below:'
            }}
          </ng-template>
        </p>
      </div>

      <form [formGroup]="detailsForm" (ngSubmit)="submitDetailsForm($event)">
        <input
          type="hidden"
          name="university_id"
          id="university_id"
          formControlName="university_id"
        />

        <div class="form-row" *ngIf="!isUnihome">
          <div class="form-field" (click)="displayUniLookupModal()">
            <label for="university_name">
              {{ pageData.university_name || 'University name' }}
            </label>
            <div class="lookup-wrapper">
              <input
                class="modal-lookup"
                formControlName="university_name"
                type="text"
                name="university_name"
                id="university_name"
                [class.error]="
                  (detailsSubmitted ||
                    detailsControl['university_name'].dirty) &&
                  detailsControl['university_id'].errors
                "
                (focus)="displayUniLookupModal()"
              />
              <a
                href="#"
                class="lookup-list-link"
                id="uni-lll"
                (click)="displayUniListModal($event)"
              >
                List
              </a>
            </div>
            <span
              class="error"
              *ngIf="
                (detailsSubmitted || detailsControl['university_name'].dirty) &&
                detailsControl['university_id'].errors
              "
            >
              {{
                pageData.university_name_error ||
                  'Please select or enter your University or College'
              }}
            </span>
          </div>
        </div>

        <app-modal
          [(show)]="showUniLookupModal"
          [showBuddy]="true"
          #uniLookupModal
        >
          <h3 class="modal-title">
            {{ pageData.university_name || 'University name' }}
          </h3>
          <app-uni-lookup
            (closeSelf)="hideUniSelectionModals()"
            (uniSelected)="universitySelected($event)"
            (addUni)="changeShowAddUniModal($event)"
            (alternativeUni)="handleNotAtUni()"
            [noUnisFoundMessage]="
              pageData.no_unis_found_message ||
              'No Universities found containing'
            "
            [searchTerm]="uniLookupSearchTerm"
            #uniLookup
          ></app-uni-lookup>
        </app-modal>

        <app-modal [(show)]="showUniAddModal" [showBuddy]="true" #uniAddModal>
          <h3 class="modal-title">Add your University or College</h3>
          <app-uni-add
            (uniAdded)="universityEntered($event)"
            [prefill]="addUniPrefill"
            #uniAdd
          ></app-uni-add>
        </app-modal>

        <app-modal [(show)]="showUniListModal" [showBuddy]="true" #uniListModal>
          <h3 class="modal-title">
            {{
              pageData.list_modal_title || 'Choose your University or College'
            }}
          </h3>
          <app-uni-list
            (uniSelected)="universitySelected($event)"
            (addUni)="changeShowAddUniModal($event)"
            (alternativeUni)="handleNotAtUni()"
            [noUnisFoundForLetterMessage]="
              pageData.no_unis_found_with_that_letter_message ||
              'No Universities or Colleges could be found with that letter. Please add your University/College.'
            "
          ></app-uni-list>
        </app-modal>

        <input
          type="hidden"
          name="residence_id"
          id="residence_id"
          formControlName="residence_id"
        />

        <div class="form-row" *ngIf="!isUnihome">
          <div class="form-field" (click)="displayResidenceLookupModal()">
            <div class="label-container">
              <label for="residence_name">
                {{
                  accommodationStayingText ||
                    'Where are you staying whilst at university?'
                }}
              </label>
              <app-tooltip
                *ngIf="pageData.staying_tooltip && !isPathwayProvider"
                id="staying_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>

            <p>{{ pageData.staying_info_copy }}</p>

            <div class="lookup-wrapper">
              <input
                class="modal-lookup"
                formControlName="residence_name"
                type="text"
                name="residence_name"
                id="residence_name"
                [class.error]="
                  (detailsSubmitted ||
                    detailsControl['residence_name'].dirty) &&
                  detailsControl['residence_id'].errors
                "
                (focus)="displayResidenceLookupModal()"
              />
              <a
                href="#"
                class="lookup-list-link"
                id="residence-lll"
                (click)="displayResidenceListModal($event)"
              >
                List
              </a>
            </div>

            <span
              class="error"
              *ngIf="
                (detailsSubmitted || detailsControl['residence_name'].dirty) &&
                detailsControl['residence_id'].errors
              "
            >
              {{
                pageData.staying_error ||
                  'Please select or enter your accommodation whilst at University'
              }}
            </span>
          </div>
        </div>

        <!-- Accommodation list search  -->
        <app-modal
          [(show)]="showResidenceLookupModal"
          [showBuddy]="true"
          #residenceLookupModal
        >
          <h3 class="modal-title">
            {{
              accommodationStayingText ||
                'Where are you staying whilst at university?'
            }}
          </h3>
          <p>{{ pageData.staying_info_copy }}</p>
          <app-residence-lookup
            (closeSelf)="hideResidenceSelectionModals()"
            (residenceSelected)="residenceSelected($event)"
            (alternateResidence)="handleAlternateResidence($event)"
            [noResidencesFoundMessage]="
              pageData.no_accommodations_found_message ||
              'No accommodations found containing'
            "
            [searchTerm]="residenceLookupSearchTerm"
            #residenceLookup
          ></app-residence-lookup>
        </app-modal>

        <app-modal
          [(show)]="showResidenceListModal"
          [showBuddy]="true"
          #residenceListModal
        >
          <h3 class="modal-title">
            {{
              accommodationStayingText ||
                'Where are you staying whilst at university?'
            }}
          </h3>
          <p>{{ pageData.staying_info_copy }}</p>
          <app-residence-list
            (residenceSelected)="residenceSelected($event)"
            (alternateResidence)="handleAlternateResidence($event)"
            [noResidencesFoundForLetterMessage]="
              pageData.no_accommodations_found_with_that_letter_message ||
              'No accommodations found for that letter group'
            "
          ></app-residence-list>
        </app-modal>

        <app-modal
          [(show)]="showResidenceAddModal"
          [showBuddy]="true"
          #residenceAddModal
        >
          <h3 class="modal-title">Add your university accommodation</h3>
          <app-residence-add
            (residenceAdded)="residenceEntered($event)"
            [prefill]="addResidencePrefill"
            #residenceAdd
          ></app-residence-add>
        </app-modal>

        <a
          *ngIf="isUnihome"
          class="unihome-link"
          (click)="noLongerAUniHomeCustomer()"
        >
          I am no longer a Unihomes customer
        </a>

        <div class="form-row" *ngIf="isUnihome">
          <div class="form-field">
            <div class="label-container">
              <label for="postcode">{{
                this.pageData.postcode_name ??
                  'Enter postcode of where you are staying'
              }}</label>
              <app-tooltip
                *ngIf="pageData.postcode_name_tooltip"
                id="postcode_name_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <!-- setting autocomplete value stops field autocompleting -->
            <input
              class="modal-lookup postcode-width"
              formControlName="postcode"
              type="text"
              name="postcode"
              id="postcode"
              autocomplete="postcode"
              [class.error]="
                (detailsSubmitted || detailsControl['postcode'].dirty) &&
                detailsControl['postcode'].errors
              "
            />
          </div>
        </div>

        <div class="error-block-container">
          <app-error-block *ngIf="detailsError">
            {{
              pageData.user_error_message ||
                'There was a problem updating your details.'
            }}
          </app-error-block>
          <app-success-block *ngIf="detailsSuccess">
            {{
              pageData.user_success_message || 'Your details have been updated'
            }}
          </app-success-block>
        </div>

        <div class="button-container">
          <button type="submit" [class.button-loading]="updating">
            <span>Save changes</span>
          </button>
          <a routerLink="/app/my-insurance">
            <button type="button" class="primary-outline">Cancel</button>
          </a>
        </div>
      </form>
    </div>

    <div class="cover-container" *ngIf="pageData?.cover_image">
      <img
        [src]="pageData.cover_image.data.attributes.url"
        alt="Registration Cover Image"
      />
    </div>
  </div>
</section>

<app-modal [(show)]="showConfirm" (showChange)="confirmModalClosed($event)">
  <div class="confirm-changes-modal-content">
    <h2>{{ pageData.confirm_modal_heading || 'Confirm your changes' }}</h2>
    <p>
      {{
        pageData.confirm_modal_text ||
          'Please note: Updating your details will only update your My Endsleigh account. If you have purchased insurance from one of our partners, please contact them directly to update your details.'
      }}
    </p>
    <button
      class="secondary h-align"
      [class.button-loading]="updating"
      (click)="doConfirm()"
    >
      <span>{{ pageData.confirm_modal_button || 'Confirm changes' }}</span>
    </button>
  </div>
</app-modal>

<app-modal
  *ngIf="shouldShowCYC"
  [show]="shouldShowCYC"
  [showBuddy]="false"
  [cycModal]="true"
  (showChange)="onCoverModalDisplayChange($event)"
>
  <app-confirm-your-cover></app-confirm-your-cover>
</app-modal>

<app-modal [(show)]="showTooltipModal" [showBuddy]="false">
  <app-tooltip-modal [content]="tooltipModalContent"></app-tooltip-modal>
</app-modal>
